module.exports = __webpack_public_path__ + "static/img/noPosts.ab51e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/noPosts.png
// module id = 767
// module chunks = 0 1 3